<template>
  <div class="mit-admin-page mit-page">

    <v-container fluid>
        <BaseMitLoading :show="loading" :fullscreen="false"/>
        <v-snackbar top :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
            <b>{{ status.message }}</b>
        </v-snackbar>
        <v-row>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card" style="width:100%">
                <v-card-title>Admin - Import Reservations</v-card-title>
                <v-card-subtitle class="caption">Import or clear the reservations.</v-card-subtitle>
                <v-divider></v-divider>

                <v-card-text>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-btn small @click="deleteImported">Clear Imported</v-btn>
                  </v-row>

                  <v-row>
                    <v-col col="12">
                      <span v-if="reservations.length <= 0" class="d-flex flex-row pa-5" style="background-color:lightgray;">
                        <v-icon color="primary" :size="'110px'">mdi-file-import</v-icon>
                        <div>
                            <p>Drag and drop a reservation CSV file here. </p>
                            <p>OR</p>
                            <input type="file" id="tsvInput" accept=".tsv" v-on:change="importFileOpen">
                            <br>
                          </div>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row v-if="previewReservationList.length > 0">
                    <v-col col="12">
                      <v-btn small class="mr-5" :disabled="recurring.length < 1" @click="saveRecurring">Import Recurring</v-btn>
                      <v-btn small :disabled="reservations.length < 1" @click="saveReservations">Import Reservations</v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col col="12">
                      <BaseMitDataTable
                        title="Reservations To Import"
                        :editable="false"
                        :headers="headers"
                        :items="previewReservationList"
                        :showExpanded="true" 
                        itemKey="data.externalId"
                        :singleExpanded="false"
                      >
                      <template #item.data-table-expand="{ index, item, isExpanded, expand }">
                          <!-- @click="expand(!isExpanded)"  -->
                          <td v-if="item.recurring" class="text-start">
                            <v-btn icon 
                                  @click="expand(!isExpanded)"
                                  class="v-data-table__expand-icon"
                                  :class="{'v-data-table__expand-icon--active' : isExpanded}">
                              <v-icon>mdi-chevron-down</v-icon>
                            </v-btn>
                          </td>
                      </template>
                      <template v-slot:item.icon="{ item }">
                        <v-icon v-if="item.recurring" color="primary darken-1" class="pr-3">mdi-calendar-refresh-outline</v-icon>
                        <v-icon v-else color="primary darken-1" class="pr-3">mdi-calendar-today-outline</v-icon>
                      </template>
                      <template v-slot:expanded-item="{ item }">
                          <!-- expand across all the columns, so use the header length -->
                          <td class="pa-1" v-if="item.children" :colspan="headers.length+1">
                              <v-simple-table class="row-pointer" fixed-header height="300px">
                                <template v-slot:default >
                                  <!-- <span v-if="reservations && reservations.length > 0"> -->
                                      <thead>
                                        <tr>
                                            <th class="text-left">External Id</th>
                                            <th class="text-left">Name</th>
                                            <th class="text-left">Space</th>
                                            <th class="text-left">Start</th>
                                            <th class="text-left">Duration</th>
                                            <th class="text-left">Setup State</th>
                                            <th class="text-left">Setup Description</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <!-- @click="editReservation(r)" -->
                                        <tr v-for="r in item.children" :key="r.id">
                                          <td>{{ r.data.externalId }}</td>
                                          <td><h4>{{r.name || '(none)'}}</h4></td>
                                          <td>{{ r.mitId }}</td>
                                          <td>{{ r.startDateTimeDisplay2 }}</td>
                                          <td>{{ r.durationDisplay1 }}</td>
                                          <td>{{ r.setupState }}</td>
                                          <td>{{ r.setupDescription }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                              </v-simple-table>
                          </td>
                      </template>
                          <!-- <template v-slot:expanded-item="{ item }">
                              <td class="pa-1" :colspan="headers.length+1">
                                <v-card v-if="loadingChildren" elevation="0" height="300">
                                                <v-card-text class="text-center">
                                                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                                    <div>Loading...</div>
                                                </v-card-text>
                                            </v-card>
                                <v-simple-table v-else class="row-pointer" fixed-header height="300px">
                                  <template v-slot:default >
                                        <thead>
                                          <tr>
                                              <th class="text-left">External ID</th>
                                              <th class="text-left">Name</th>
                                              <th class="text-left">Space</th>
                                              <th class="text-left">Start</th>
                                              <th class="text-left">Duration</th>
                                              <th class="text-left">Setup State</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="r in item.children" :key="r.id">
                                            <td>{{ r.externalId }}</td>
                                            <td><h4>{{r.name || '(none)'}}</h4></td>
                                            <td>{{ r.mitId }}</td>
                                            <td>{{ r.startDateTimeDisplay2 }}</td>
                                            <td>{{ r.durationDisplay1 }}</td>
                                            <td>{{ r.setupState }}</td>
                                          </tr>
                                      </tbody>
                                  </template>
                                </v-simple-table>
                              </td>
                          </template>
                          <template v-slot:item.icon="{ item }">
                                        <v-icon v-if="item.recurring" color="primary darken-1" class="pr-3">mdi-calendar-refresh-outline</v-icon>
                                        <v-icon v-else color="primary darken-1" class="pr-3">mdi-calendar-today-outline</v-icon>
                          </template>
                          <template #item.data-table-expand="{ index, item, isExpanded, expand }">
                            <td v-if="item.recurring" class="text-start">
                              <v-btn icon 
                                    @click="expand(!isExpanded)"
                                    class="v-data-table__expand-icon"
                                    :class="{'v-data-table__expand-icon--active' : isExpanded}">
                                <v-icon>mdi-chevron-down</v-icon>
                              </v-btn>
                            </td>
                        </template> -->
                      </BaseMitDataTable>
                      </v-col>
                    </v-row>
                </v-card-text>

            </v-card>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script>
  import BaseMitDataTable from '../../../base/components/BaseMitDataTable.vue';
  import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';
  import MitImportReservationService from '../../services/MitImportReservationService.js';

  export default {
    name: 'MitAdminPage',
    components: {
        BaseMitLoading,
        BaseMitDataTable
    },
    data: function() {
      return {
          status:{
            display:false,
            timeout:6000,
            message:'Saved!',
            color:'primary'
          },
          loading:false,
          previewReservationList:[],//preview
          recurring:[],//list to upload
          reservations:[],//single reservation list to upload
          headers:[
            { text: '', value: 'data-table-expand', width:10 },
            {text: '',sortable: true,value: 'icon', width:10},
            {text: 'External Id',sortable: true,value: 'data.externalId'},
            {text: 'External Series Id',sortable: true,value: 'data.externalSeriesId'},
            {text: 'Name',sortable: true,value: 'name'},
            {text: 'Space',sortable: false,value: 'mitId'},
            {text: 'Start',sortable: false,value: 'startDateTimeDisplay2'},
            {text: 'End',sortable: false,value: 'endDateTimeDisplay2'},
            {text: 'Owner',sortable: false,value: 'owner'},
            {text: 'Setup',sortable: false,value: 'setupState'}
          ]
      }
    },
    methods: {
        importFileOpen(event) {
          var files = event.target.files; // file list from input

          MitImportReservationService.loadFromFile(files[0])
              .then((fileData) => {
                  let jsonData = MitImportReservationService.parseTSV(fileData);
                 //console.log('IMPORT LOADED', jsonData);
                  let basicReservations = MitImportReservationService.createReservationModels(jsonData);
                  //console.log('IMPORT Recurring Reservations', recurringRes);
                  let result = MitImportReservationService.buildAPIModels(basicReservations);
                  this.recurring = result.recurring;
                  this.reservations = result.reservations;
                  this.previewReservationList = result.all;
              })
              .catch((error) => {
                  this.loadingGet = false;
                  this.status.message = 'An error occurred trying to import the file.';
                  this.status.display = true;
                  this.status.color = 'red';
                  console.log('ERROR:', error);
              });
        },
        filter (item, queryText, itemText) {
          return item.mitId.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
                 item.org.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
                 item.useType.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
                 item.owner.toLowerCase().indexOf(queryText.toLowerCase()) > -1 || 
                 item.name.toLowerCase().indexOf(queryText.toLowerCase()) > -1
        },
        import(csv){
            this.loadingGet = true;
            this.reservations = MitImportReservationService.parseCSVRecurring(csv);
        },
        clearImport(){
          this.recurring = [];
          this.reservations = [];
          this.previewReservationList = [];
        },
        deleteImported(){
          this.loading = true;
          MitImportReservationService.deleteImportedReservations()
              .then((data) => {
                   console.log('SUCCESS deleted:',data)
                  this.loading = false;
                  this.status.message = 'Deleted, ';
                  this.status.color = 'primary';
                  this.status.display = true;
              })
              .catch((error) => {
                  this.loading = false;
                  this.status.message = 'An error occurred trying to import recurring reservations.';
                  this.status.display = true;
                  this.status.color = 'red';
                  console.log('ERROR:', error);
              });
        },
        saveRecurring(){
          this.loading = true;
          MitImportReservationService.saveRecurring(this.recurring)
              .then((data) => {
                  this.reservations = [];
                  this.loading = false;
                  this.status.message = 'Saved! Imported: '+data.success + ' recurring reservations';
                  this.status.color = 'primary';
                  this.status.display = true;
                  this.clearImport();
              })
              .catch((error) => {
                  this.loading = false;
                  this.status.message = 'An error occurred trying to import recurring reservations.';
                  this.status.display = true;
                  this.status.color = 'red';
                  console.log('ERROR:', error);
                  this.clearImport();
              });
        },
        saveReservations(){
          this.loading = true;
          MitImportReservationService.saveReservations(this.reservations)
              .then((data) => {
                  this.reservations = [];
                  this.loading = false;
                  this.status.message = 'Saved! Imported: '+data.success + ' single reservations';
                  this.status.color = 'primary';
                  this.status.display = true;
                  this.clearImport();
              })
              .catch((error) => {
                  this.loading = false;
                  this.status.message = 'An error occurred trying to import single reservations.';
                  this.status.display = true;
                  this.status.color = 'red';
                  console.log('ERROR:', error);
                  this.clearImport();
              });
        }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
</style>
